import {
  flow,
  get,
  pick,
  kebabCase,
  keys,
  omit,
  reduce,
  map,
  includes,
} from 'lodash/fp';
import {
  SEO_PAGE_CITY,
  SEO_PAGE_CITY_MAKE,
  SEO_PAGE_CITY_MODEL,
  SEO_PAGE_MAKE,
  SEO_PAGE_MODEL,
  SEO_PAGE_SUBTYPE,
} from 'constants/seoPageType';

const isCityPage = (type) =>
  includes(type, ['cities', 'cityMakes', 'cityModels']);

const mapLinks = (type, cityPriority) =>
  flow(
    get(type),
    map(({ url, title }) => {
      const [cityTitle, vehicleTitle] = isCityPage(type)
        ? title.split(',')
        : [null, title];

      return {
        title: cityPriority ? cityTitle : vehicleTitle,
        url,
      };
    }),
  );

const mapValues = (obj) =>
  flow(
    pick(['makes', 'models', 'subtypes']),
    keys,
    reduce((memo, key) => {
      memo[key] = mapLinks(key)(obj);

      return memo;
    }, {}),
  )(obj);

const getLinks = (links, type) => {
  const base = {
    ...mapValues(links),
    cities: mapLinks('cities', true)(links),
  };

  switch (type) {
    case SEO_PAGE_MAKE:
      return {
        ...base,
        cityMakesByMake: mapLinks('cityMakes', true)(links),
      };
    case SEO_PAGE_CITY:
      return {
        ...base,
        cityMakesByCity: mapLinks('cityMakes')(links),
      };
    case SEO_PAGE_CITY_MAKE:
      return {
        ...base,
        cityModelsByCityMake: mapLinks('cityModels')(links),
      };
    case SEO_PAGE_CITY_MODEL:
      return {
        ...base,
        cityModelsByCityModel: mapLinks('cityModels', true)(links),
      };
    case SEO_PAGE_MODEL:
      return {
        ...base,
        cityModelsByModel: mapLinks('cityModels', true)(links),
      };
    case SEO_PAGE_SUBTYPE:
      return {
        ...base,
        cityModelsBySubtype: mapLinks('cityModels', true)(links),
      };
    default:
      return {
        ...base,
      };
  }
};

export const getCmsContent = (response) => {
  const { links, cmsContent, searchMeta, type: template } = response.result;

  const meta = flow(
    keys,
    reduce((memo, key) => {
      memo[kebabCase(key)] = searchMeta[key];

      return memo;
    }, {}),
  )(searchMeta);

  const linkType = get('link-type', meta);

  return {
    ...omit(['cmsContent', 'searchMeta', 'type'], response.result),
    ...omit(
      ['ad-title', 'breadcrumbs-meta', 'link-meta', 'link-type'],
      cmsContent,
    ),
    ...meta,
    links: getLinks(links, linkType),
    template,
  };
};
